import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { DataService_StudentLocker } from "./shared/data.service";
import { StudentAddLockerComponent } from "./student-add-locker/student-add-locker.component";
import { StudentEditLockerComponent } from "./student-edit-locker/student-edit-locker.component";
import { StudentRemoveLockerComponent } from "./student-remove-locker/student-remove-locker.component";
import * as moment from "moment";

@Component({
	selector: "app-student-lockers",
	templateUrl: "./student-lockers.component.html",
	styleUrls: ["./student-lockers.component.css"],
})
export class StudentLockersComponent implements OnInit {
	constructor(
		private userService: UserService,
		private StudentLockerService: DataService_StudentLocker,
		private dialogService: DialogService,
		private selectService: PersonSelectorService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadLockerPerson();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Person Selector
	subscription: Subscription;
	SelectedPerson: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedLockerPerson: any;
	lstLockerPerson: any = [];

	//Filter lists
	lstAssignedDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LockerNum", header: "Locker Number" },
		{ field: "LockerComment", header: "Locker Comment/Combination" },
		{ field: "MoveInDateDesc", header: "Move In" },
		{ field: "MoveOutDateDesc", header: "Move Out" },
		{ field: "AssignmentComments", header: "Comments" },
		{ field: "AssignedDesc", header: "Already Moved Out" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadLockerPerson() {
		if (this.SelectedPerson == undefined) {
			return;
		}

		this.loading = true;

		var result = this.StudentLockerService.LockerSelectByPerson(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstLockerPerson = response;

				for (var i = 0; i < this.lstLockerPerson.length; i++) {
					var next = this.lstLockerPerson[i];

					next.MoveInDateDesc = moment(new Date(next.MoveInDate)).format("MM/DD/YYYY");
					next.MoveOutDateDesc = moment(new Date(next.MoveOutDate)).format("MM/DD/YYYY");

					//Null value
					if (next.MoveOutDateDesc == "01/01/0001") {
						next.MoveOutDateDesc = "";
					}
				}

				//Load Data Filter Lists
				this.lstAssignedDesc = Array.from(new Set(this.lstLockerPerson.map((item: any) => item.AssignedDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadLockerPerson();
	}

	//Custom Button Methods
	onAssignLocker() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentAddLockerComponent, {
			header: "Assign Locker",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLockerPerson();
			}
		});
	}

	onEditAssignment() {
		this.errorMessage = "";

		if (this.SelectedLockerPerson == undefined) {
			this.errorMessage = "Select a locker assignment to edit";
			return;
		}

		var ref = this.dialogService.open(StudentEditLockerComponent, {
			header: "Edit Assignment",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedLockerPerson: this.SelectedLockerPerson,
				SelectedPerson: this.SelectedPerson,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLockerPerson();
			}
		});
	}

	onUnassignLocker() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentRemoveLockerComponent, {
			header: "Unassign Locker",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedLockerPerson: this.SelectedLockerPerson,
				SelectedPerson: this.SelectedPerson,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLockerPerson();
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedLockerPerson = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedLockerPerson = null;
	}
	onRowDblClick(LockerPerson) {
		this.errorMessage = "";

		this.SelectedLockerPerson = LockerPerson;

		if (this.EnableEdit() == true) {
			this.onEditAssignment();
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	EnableEdit() {
		if (this.SelectedLockerPerson == undefined) {
			return false;
		} else if (this.SelectedLockerPerson.MoveOutDateDesc != "") {
			return false;
		} else {
			return true;
		}
	}

	////////////////////////////////////////////
}
